import { render, staticRenderFns } from "./ManageOrderSlider.vue?vue&type=template&id=529c0038&scoped=true&"
import script from "./ManageOrderSlider.vue?vue&type=script&lang=js&"
export * from "./ManageOrderSlider.vue?vue&type=script&lang=js&"
import style0 from "./ManageOrderSlider.vue?vue&type=style&index=0&id=529c0038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c0038",
  null
  
)

export default component.exports